<div class="custom-page-modal ac-modal">
	<div class="top-section header">
		<h1 class="text-28-extra-bold" dcrHTMLKey="PDF_ADD_NEW_CUSTOM_PAGES">Add New Pages</h1>
	</div>
	<div class="central-section">
		<div class="wizard">
			<div class="step">
				<div>
					<div *ngIf="showErrors" class="padding-bottom-20">
						<dz-block-alert type="error">
							<p class="padding-bottom-10" dcrHTMLKey="PDF_GENERATE_FILE_UPLOAD_FAILED_ERROR_MESSAGE">
								Your upload failed due to these files either being larger than 2MB or the incorrect image format:
							</p>
							<ng-container *ngFor="let message of errorMessageArray">
								<p class="padding-left-10">
									{{ message }}
								</p>
							</ng-container>
						</dz-block-alert>
					</div>
					<div>
						<button dz-button color="secondary" [dropzone]="dzConfig" (addedFiles)="filesAdded($event)" dcrHTMLKey="PDF_GENERATE_CHOOSE_FILE">
							Choose files for upload
						</button>
					</div>
					<section class="text-14 upload-instructions" dcrHTMLKey="PDF_CUSTOM_PAGE_ACCEPTED_FORMATS">
						<p>Browse to upload your image files or drag-and-drop onto the preview on the right.</p>
						<p>Accepted Formats: JPG, PNG.</p>
						<p>Max file size: 2MB.</p>
					</section>
				</div>
			</div>
		</div>
	</div>
	<div class="row lower-section footer">
		<button dz-button color="secondary" dcrHTMLKey="PDF_CUSTOM_PAGE_CANCEL" (click)="onCancel()">Cancel</button>
	</div>
</div>
